'use strict';

/**
 * Directive: filters
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdFilters for ES6 usage
 *          5.0.1 #286 Standardise Data Loading and Parsing Services
 *          3.0.0 #236 Add Shared Functionality to Main Library
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2015-2020  Build Centrix
 */
var wdFilters = angular.module('wd.directives.filters', [])
    .directive(
    'wdFilters',
    function ()
    {
        return {
            restrict: 'E',
            scope: {
                filterService: '=filterService'
            },
            link: function (scope)
            {
                console.log(scope.filterService);
            },
            template: '<div>Testing</div>'
        };
    });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdFilters;
}     
// EOF